import { useEffect, useState } from 'react';

const VIEW_PORT = {
  MOBILE: 540,
  TABLET: 1024,
};

function useDeviceDetect() {
  // Always use same initial state for SSR and first client render (hydration-safe)
  const [windowSize, setWindowSize] = useState<{ width: number; height: number }>(
    () => ({ width: 0, height: 0 })
  );

  useEffect(() => {
    if (globalThis.window === undefined) {
      return;
    }
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });

    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const width = windowSize.width;

  return {
    windowSize,
    isMobile: width > 0 && width <= VIEW_PORT.MOBILE,
    isTablet: width > VIEW_PORT.MOBILE && width <= VIEW_PORT.TABLET,
    isDesktop: width > VIEW_PORT.TABLET,
  };
}

export default useDeviceDetect;